export default function TrustSection() {
  const items = [
    {
      icon: 'ri-shield-check-line',
      title: 'Data Protection',
      desc: 'Reduce information risks with structured data management practices and secure spreadsheet workflows.',
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Privacy Guidelines',
      desc: 'Maintain better control over sensitive information with clear privacy-aware spreadsheet practices.',
    },
    {
      icon: 'ri-error-warning-line',
      title: 'Safe Usage',
      desc: 'Prevent costly mistakes with validated templates that include built-in error checking and safeguards.',
    },
    {
      icon: 'ri-database-2-line',
      title: 'Backup Practices',
      desc: 'Protect your important files with recommended backup strategies and version control workflows.',
    },
  ];

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            Trust & Security
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Your Spreadsheet Security Matters
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            We focus on secure spreadsheet practices, responsible data management, privacy awareness, and safe business workflows.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {items.map((item, idx) => (
            <div
              key={idx}
              className="p-6 rounded-xl bg-background-50 border border-background-200 text-center"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-4">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}